import axios from 'axios';
import { getChannelToken_v1 } from 'js/library/utils/API/getChannelToken_v1';
import cfac22 from '../cfac22';

export function getUserOrgs(uId) {
  return new Promise((resolve, reject) => {
    getChannelToken_v1(uId)
      .then((result) => {
        //console.log('RESULTADO GET CHANNEL TOKEN ===>', result);
        axios
          .post(
            cfac22('API_HOST_V1') + 'getUserOrgs',
            {
              triiboHeader: {
                apiToken: cfac22('apiToken'),
                channelGroup: cfac22('channelGroup'),
                channelName: cfac22('channelName'),
                uId: uId,
                channelTokenId: result,
                channelId: cfac22('channelId'),
                sessionId: '001',
                transactionId: '002',
              },
              uId: uId,
            },
            {
              headers: {
                'Full-Url': window.location.href,
              },
            }
          )
          .then((result) => {
            //console.log('RESULTADO GET USER ORGS ===>', result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log('ERROR GET USER ORGS ---->', error.response);
            reject(error);
          });
      })
      .catch((error) => {
        //console.log('ERROR GET CHANNEL TOKEN ---->', error);
        reject(error);
      });
  });
}
